import { render, staticRenderFns } from "./FosForm.vue?vue&type=template&id=79726005&scoped=true"
import script from "./FosForm.vue?vue&type=script&lang=js"
export * from "./FosForm.vue?vue&type=script&lang=js"
import style0 from "./FosForm.vue?vue&type=style&index=0&id=79726005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79726005",
  null
  
)

export default component.exports